import React from "react";

import { SS23 } from "../../../../js/database/database-ss23.js";

import ProductsContainer from "../../../../components/containers/ProductsContainer.js";
import { SwiperSlide } from "swiper/react";

const SleazyNetKnitApricot = () => {
  return (
    <ProductsContainer
      pageTitle={SS23.tops.SleazyNetKnitApricot.itemName}
      name={SS23.tops.SleazyNetKnitApricot.itemName}
      price={SS23.tops.SleazyNetKnitApricot.itemPrice}
      fabric={SS23.tops.SleazyNetKnitApricot.itemFabric}
      src={SS23.tops.SleazyNetKnitApricot.sizeChart}
      divId={SS23.tops.SleazyNetKnitApricot.shopifyDivId}
      mainId={SS23.tops.SleazyNetKnitApricot.shopifyId}
      buttonShouldHide={true}
    >
      {React.Children.toArray(
        SS23.tops.SleazyNetKnitApricot.pictures.map(({ srcJpeg }) => (
          <SwiperSlide>
            <img
              src={srcJpeg}
              alt={SS23.tops.SleazyNetKnitApricot.itemName}
              width={SS23.imgWidth}
              height={SS23.imgHeight}
              loading={SS23.loading}
            />
          </SwiperSlide>
        ))
      )}
    </ProductsContainer>
  );
};

export default SleazyNetKnitApricot;
